(() => {
  const PRICE_SORTS = new Set(['price-ascending', 'price-descending']);

  function getOriginalArtworkFilters() {
    const params = new URLSearchParams(window.location.search);
    const availability = new Set(
      params
        .getAll('filter.v.availability')
        .flatMap((value) => value.split(','))
        .filter(Boolean),
    );

    const minimumValue = params.get('filter.v.price.gte');
    const maximumValue = params.get('filter.v.price.lte');
    const minimumPounds = minimumValue === null || minimumValue.trim() === '' ? null : Number(minimumValue);
    const maximumPounds = maximumValue === null || maximumValue.trim() === '' ? null : Number(maximumValue);

    return {
      availability,
      minimumPrice:
        minimumPounds !== null && Number.isFinite(minimumPounds) && minimumPounds > 0
          ? Math.round(minimumPounds * 100)
          : null,
      maximumPrice:
        maximumPounds !== null && Number.isFinite(maximumPounds) && maximumPounds >= 0
          ? Math.round(maximumPounds * 100)
          : null,
    };
  }

  function updateProductCount(count) {
    ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
      const countElement = document.getElementById(id);
      if (countElement) countElement.textContent = `${count} ${count === 1 ? 'product' : 'products'}`;
    });
  }

  function applyOriginalArtworkFilters(root = document) {
    const filters = getOriginalArtworkFilters();

    root.querySelectorAll('[data-original-artwork-sort="true"]').forEach((grid) => {
      let visibleCount = 0;

      Array.from(grid.children).forEach((item) => {
        if (item.hasAttribute('data-original-filter-message')) return;

        const price = Number(item.dataset.originalArtworkPrice || 0);
        const available = item.dataset.originalArtworkAvailable === 'true';
        const matchesMinimum = filters.minimumPrice === null || price >= filters.minimumPrice;
        const matchesMaximum = filters.maximumPrice === null || price <= filters.maximumPrice;
        const matchesAvailability =
          filters.availability.size === 0 ||
          (available && filters.availability.has('1')) ||
          (!available && filters.availability.has('0'));
        const visible = matchesMinimum && matchesMaximum && matchesAvailability;

        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      let emptyMessage = grid.querySelector('[data-original-filter-message]');
      if (!emptyMessage) {
        emptyMessage = document.createElement('li');
        emptyMessage.setAttribute('data-original-filter-message', '');
        emptyMessage.className = 'grid__item';
        emptyMessage.style.gridColumn = '1 / -1';
        emptyMessage.style.textAlign = 'center';
        emptyMessage.style.padding = '4rem 1rem';
        emptyMessage.textContent = 'No original artworks match these filters.';
        grid.appendChild(emptyMessage);
      }
      emptyMessage.hidden = visibleCount !== 0;

      updateProductCount(visibleCount);
    });
  }

  function sortOriginalArtworkGrids(root = document) {
    root.querySelectorAll('[data-original-artwork-sort="true"]').forEach((grid) => {
      const sortBy = grid.dataset.sortBy;

      if (!PRICE_SORTS.has(sortBy)) return;

      const items = Array.from(grid.children);
      const sortedItems = items
        .map((item, index) => ({
          item,
          index,
          price: Number(item.dataset.originalArtworkPrice || 0),
        }))
        .sort((a, b) => {
          const priceDifference =
            sortBy === 'price-ascending' ? a.price - b.price : b.price - a.price;

          return priceDifference || a.index - b.index;
        })
        .map(({ item }) => item);

      const orderChanged = sortedItems.some((item, index) => item !== items[index]);
      if (!orderChanged) return;

      const fragment = document.createDocumentFragment();
      sortedItems.forEach((item, index) => {
        item.style.setProperty('--animation-order', index + 1);
        fragment.appendChild(item);
      });
      grid.appendChild(fragment);
    });

    applyOriginalArtworkFilters(root);
  }

  let sortScheduled = false;
  function scheduleSort() {
    if (sortScheduled) return;
    sortScheduled = true;

    requestAnimationFrame(() => {
      sortScheduled = false;
      sortOriginalArtworkGrids();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSort, { once: true });
  } else {
    scheduleSort();
  }

  const observer = new MutationObserver((mutations) => {
    const productGridChanged = mutations.some((mutation) => {
      const target = mutation.target;
      return target instanceof Element && Boolean(target.closest('#ProductGridContainer'));
    });

    if (productGridChanged) scheduleSort();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
